export default __webpack_public_path__ + "static/media/grafana.ebfbf708.png";